import React, { useState } from 'react';
import  '../../styles/Sidebar.css';
import  '../../styles/Dashboard.css';
import  '../../styles/RequestForms.css';
import Supplier from '../../components/Supplier';

const SupplierPage = () => {
  return <Supplier />;
};

export default SupplierPage;
